/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UmoRouteImport } from './routes/umo'
import { Route as MobileSmsRouteImport } from './routes/mobile-sms'
import { Route as MobilePushRouteImport } from './routes/mobile-push'
import { Route as GrapesPreviewRouteImport } from './routes/grapes-preview'
import { Route as GrapesRouteImport } from './routes/grapes'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthAuthViewRouteImport } from './routes/auth/$authView'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppOrganizationRouteRouteImport } from './routes/_app/organization/route'
import { Route as AppSchemaBuilderIndexRouteImport } from './routes/_app/schema-builder/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppOrganizationIndexRouteImport } from './routes/_app/organization/index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppOrganizationSettingsRouteImport } from './routes/_app/organization/settings'
import { Route as AppOrganizationMembersRouteImport } from './routes/_app/organization/members'
import { Route as AppOrganizationBillingRouteImport } from './routes/_app/organization/billing'
import { Route as AppOrganizationApiKeysRouteImport } from './routes/_app/organization/api-keys'
import { Route as AppCliProjectSelectSessionIdRouteImport } from './routes/_app/cli-project-select/$sessionId'
import { Route as AppAccountAccountViewRouteImport } from './routes/_app/account/$accountView'
import { Route as AppCliAuthSessionIdIndexRouteImport } from './routes/_app/cli-auth/$sessionId/index'
import { Route as AppProjectsProjectSlugLayoutRouteRouteImport } from './routes/_app/projects/$projectSlug/_layout/route'
import { Route as AppProjectsProjectSlugTemplatesIndexRouteImport } from './routes/_app/projects/$projectSlug/templates/index'
import { Route as AppProjectsProjectSlugLayoutIndexRouteImport } from './routes/_app/projects/$projectSlug/_layout/index'
import { Route as AppCliAuthSessionIdCompleteIndexRouteImport } from './routes/_app/cli-auth/$sessionId/complete/index'
import { Route as AppProjectsProjectSlugLayoutSettingsRouteImport } from './routes/_app/projects/$projectSlug/_layout/settings'
import { Route as AppProjectsProjectSlugLayoutMediaRouteImport } from './routes/_app/projects/$projectSlug/_layout/media'
import { Route as AppProjectsProjectSlugLayoutAnalyticsRouteImport } from './routes/_app/projects/$projectSlug/_layout/analytics'
import { Route as AppCliAuthSessionIdCompleteOrganizationSlugRouteImport } from './routes/_app/cli-auth/$sessionId/complete/$organizationSlug'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/index'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/logs'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/edit'

const AppProjectsProjectSlugRouteImport = createFileRoute(
  '/_app/projects/$projectSlug',
)()

const UmoRoute = UmoRouteImport.update({
  id: '/umo',
  path: '/umo',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileSmsRoute = MobileSmsRouteImport.update({
  id: '/mobile-sms',
  path: '/mobile-sms',
  getParentRoute: () => rootRouteImport,
} as any)
const MobilePushRoute = MobilePushRouteImport.update({
  id: '/mobile-push',
  path: '/mobile-push',
  getParentRoute: () => rootRouteImport,
} as any)
const GrapesPreviewRoute = GrapesPreviewRouteImport.update({
  id: '/grapes-preview',
  path: '/grapes-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const GrapesRoute = GrapesRouteImport.update({
  id: '/grapes',
  path: '/grapes',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthAuthViewRoute = AuthAuthViewRouteImport.update({
  id: '/auth/$authView',
  path: '/auth/$authView',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationRouteRoute = AppOrganizationRouteRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsProjectSlugRoute = AppProjectsProjectSlugRouteImport.update({
  id: '/projects/$projectSlug',
  path: '/projects/$projectSlug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSchemaBuilderIndexRoute = AppSchemaBuilderIndexRouteImport.update({
  id: '/schema-builder/',
  path: '/schema-builder/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationIndexRoute = AppOrganizationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationSettingsRoute = AppOrganizationSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationMembersRoute = AppOrganizationMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationBillingRoute = AppOrganizationBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationApiKeysRoute = AppOrganizationApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppCliProjectSelectSessionIdRoute =
  AppCliProjectSelectSessionIdRouteImport.update({
    id: '/cli-project-select/$sessionId',
    path: '/cli-project-select/$sessionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountAccountViewRoute = AppAccountAccountViewRouteImport.update({
  id: '/account/$accountView',
  path: '/account/$accountView',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCliAuthSessionIdIndexRoute =
  AppCliAuthSessionIdIndexRouteImport.update({
    id: '/cli-auth/$sessionId/',
    path: '/cli-auth/$sessionId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutRouteRoute =
  AppProjectsProjectSlugLayoutRouteRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugTemplatesIndexRoute =
  AppProjectsProjectSlugTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugLayoutIndexRoute =
  AppProjectsProjectSlugLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppCliAuthSessionIdCompleteIndexRoute =
  AppCliAuthSessionIdCompleteIndexRouteImport.update({
    id: '/cli-auth/$sessionId/complete/',
    path: '/cli-auth/$sessionId/complete/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutSettingsRoute =
  AppProjectsProjectSlugLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutMediaRoute =
  AppProjectsProjectSlugLayoutMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutAnalyticsRoute =
  AppProjectsProjectSlugLayoutAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppCliAuthSessionIdCompleteOrganizationSlugRoute =
  AppCliAuthSessionIdCompleteOrganizationSlugRouteImport.update({
    id: '/cli-auth/$sessionId/complete/$organizationSlug',
    path: '/cli-auth/$sessionId/complete/$organizationSlug',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport.update({
    id: '/templates/$templateSlug/',
    path: '/templates/$templateSlug/',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport.update({
    id: '/templates/$templateSlug/logs',
    path: '/templates/$templateSlug/logs',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugEditRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport.update({
    id: '/templates/$templateSlug/edit',
    path: '/templates/$templateSlug/edit',
    getParentRoute: () => AppProjectsProjectSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/grapes': typeof GrapesRoute
  '/grapes-preview': typeof GrapesPreviewRoute
  '/mobile-push': typeof MobilePushRoute
  '/mobile-sms': typeof MobileSmsRoute
  '/umo': typeof UmoRoute
  '/organization': typeof AppOrganizationRouteRouteWithChildren
  '/analytics': typeof AppAnalyticsRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/account/$accountView': typeof AppAccountAccountViewRoute
  '/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/organization/billing': typeof AppOrganizationBillingRoute
  '/organization/members': typeof AppOrganizationMembersRoute
  '/organization/settings': typeof AppOrganizationSettingsRoute
  '/account': typeof AppAccountIndexRoute
  '/organization/': typeof AppOrganizationIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/schema-builder': typeof AppSchemaBuilderIndexRoute
  '/projects/$projectSlug': typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  '/cli-auth/$sessionId': typeof AppCliAuthSessionIdIndexRoute
  '/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/projects/$projectSlug/analytics': typeof AppProjectsProjectSlugLayoutAnalyticsRoute
  '/projects/$projectSlug/media': typeof AppProjectsProjectSlugLayoutMediaRoute
  '/projects/$projectSlug/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/cli-auth/$sessionId/complete': typeof AppCliAuthSessionIdCompleteIndexRoute
  '/projects/$projectSlug/': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/projects/$projectSlug/templates': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/projects/$projectSlug/templates/$templateSlug': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRoutesByTo {
  '/dashboard': typeof DashboardRoute
  '/grapes': typeof GrapesRoute
  '/grapes-preview': typeof GrapesPreviewRoute
  '/mobile-push': typeof MobilePushRoute
  '/mobile-sms': typeof MobileSmsRoute
  '/umo': typeof UmoRoute
  '/analytics': typeof AppAnalyticsRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/': typeof AppIndexRoute
  '/admin': typeof AdminIndexRoute
  '/account/$accountView': typeof AppAccountAccountViewRoute
  '/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/organization/billing': typeof AppOrganizationBillingRoute
  '/organization/members': typeof AppOrganizationMembersRoute
  '/organization/settings': typeof AppOrganizationSettingsRoute
  '/account': typeof AppAccountIndexRoute
  '/organization': typeof AppOrganizationIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/schema-builder': typeof AppSchemaBuilderIndexRoute
  '/projects/$projectSlug': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/cli-auth/$sessionId': typeof AppCliAuthSessionIdIndexRoute
  '/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/projects/$projectSlug/analytics': typeof AppProjectsProjectSlugLayoutAnalyticsRoute
  '/projects/$projectSlug/media': typeof AppProjectsProjectSlugLayoutMediaRoute
  '/projects/$projectSlug/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/cli-auth/$sessionId/complete': typeof AppCliAuthSessionIdCompleteIndexRoute
  '/projects/$projectSlug/templates': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/projects/$projectSlug/templates/$templateSlug': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/grapes': typeof GrapesRoute
  '/grapes-preview': typeof GrapesPreviewRoute
  '/mobile-push': typeof MobilePushRoute
  '/mobile-sms': typeof MobileSmsRoute
  '/umo': typeof UmoRoute
  '/_app/organization': typeof AppOrganizationRouteRouteWithChildren
  '/_app/analytics': typeof AppAnalyticsRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/_app/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/_app/account/$accountView': typeof AppAccountAccountViewRoute
  '/_app/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/_app/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/_app/organization/billing': typeof AppOrganizationBillingRoute
  '/_app/organization/members': typeof AppOrganizationMembersRoute
  '/_app/organization/settings': typeof AppOrganizationSettingsRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/organization/': typeof AppOrganizationIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/schema-builder/': typeof AppSchemaBuilderIndexRoute
  '/_app/projects/$projectSlug': typeof AppProjectsProjectSlugRouteWithChildren
  '/_app/projects/$projectSlug/_layout': typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  '/_app/cli-auth/$sessionId/': typeof AppCliAuthSessionIdIndexRoute
  '/_app/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/_app/projects/$projectSlug/_layout/analytics': typeof AppProjectsProjectSlugLayoutAnalyticsRoute
  '/_app/projects/$projectSlug/_layout/media': typeof AppProjectsProjectSlugLayoutMediaRoute
  '/_app/projects/$projectSlug/_layout/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/_app/cli-auth/$sessionId/complete/': typeof AppCliAuthSessionIdCompleteIndexRoute
  '/_app/projects/$projectSlug/_layout/': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/_app/projects/$projectSlug/templates/': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/dashboard'
    | '/grapes'
    | '/grapes-preview'
    | '/mobile-push'
    | '/mobile-sms'
    | '/umo'
    | '/organization'
    | '/analytics'
    | '/admin/organizations'
    | '/admin/users'
    | '/auth/$authView'
    | '/'
    | '/admin/'
    | '/account/$accountView'
    | '/cli-project-select/$sessionId'
    | '/organization/api-keys'
    | '/organization/billing'
    | '/organization/members'
    | '/organization/settings'
    | '/account'
    | '/organization/'
    | '/projects'
    | '/schema-builder'
    | '/projects/$projectSlug'
    | '/cli-auth/$sessionId'
    | '/cli-auth/$sessionId/complete/$organizationSlug'
    | '/projects/$projectSlug/analytics'
    | '/projects/$projectSlug/media'
    | '/projects/$projectSlug/settings'
    | '/cli-auth/$sessionId/complete'
    | '/projects/$projectSlug/'
    | '/projects/$projectSlug/templates'
    | '/projects/$projectSlug/templates/$templateSlug/edit'
    | '/projects/$projectSlug/templates/$templateSlug/logs'
    | '/projects/$projectSlug/templates/$templateSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/dashboard'
    | '/grapes'
    | '/grapes-preview'
    | '/mobile-push'
    | '/mobile-sms'
    | '/umo'
    | '/analytics'
    | '/admin/organizations'
    | '/admin/users'
    | '/auth/$authView'
    | '/'
    | '/admin'
    | '/account/$accountView'
    | '/cli-project-select/$sessionId'
    | '/organization/api-keys'
    | '/organization/billing'
    | '/organization/members'
    | '/organization/settings'
    | '/account'
    | '/organization'
    | '/projects'
    | '/schema-builder'
    | '/projects/$projectSlug'
    | '/cli-auth/$sessionId'
    | '/cli-auth/$sessionId/complete/$organizationSlug'
    | '/projects/$projectSlug/analytics'
    | '/projects/$projectSlug/media'
    | '/projects/$projectSlug/settings'
    | '/cli-auth/$sessionId/complete'
    | '/projects/$projectSlug/templates'
    | '/projects/$projectSlug/templates/$templateSlug/edit'
    | '/projects/$projectSlug/templates/$templateSlug/logs'
    | '/projects/$projectSlug/templates/$templateSlug'
  id:
    | '__root__'
    | '/_app'
    | '/admin'
    | '/dashboard'
    | '/grapes'
    | '/grapes-preview'
    | '/mobile-push'
    | '/mobile-sms'
    | '/umo'
    | '/_app/organization'
    | '/_app/analytics'
    | '/admin/organizations'
    | '/admin/users'
    | '/auth/$authView'
    | '/_app/'
    | '/admin/'
    | '/_app/account/$accountView'
    | '/_app/cli-project-select/$sessionId'
    | '/_app/organization/api-keys'
    | '/_app/organization/billing'
    | '/_app/organization/members'
    | '/_app/organization/settings'
    | '/_app/account/'
    | '/_app/organization/'
    | '/_app/projects/'
    | '/_app/schema-builder/'
    | '/_app/projects/$projectSlug'
    | '/_app/projects/$projectSlug/_layout'
    | '/_app/cli-auth/$sessionId/'
    | '/_app/cli-auth/$sessionId/complete/$organizationSlug'
    | '/_app/projects/$projectSlug/_layout/analytics'
    | '/_app/projects/$projectSlug/_layout/media'
    | '/_app/projects/$projectSlug/_layout/settings'
    | '/_app/cli-auth/$sessionId/complete/'
    | '/_app/projects/$projectSlug/_layout/'
    | '/_app/projects/$projectSlug/templates/'
    | '/_app/projects/$projectSlug/templates/$templateSlug/edit'
    | '/_app/projects/$projectSlug/templates/$templateSlug/logs'
    | '/_app/projects/$projectSlug/templates/$templateSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  GrapesRoute: typeof GrapesRoute
  GrapesPreviewRoute: typeof GrapesPreviewRoute
  MobilePushRoute: typeof MobilePushRoute
  MobileSmsRoute: typeof MobileSmsRoute
  UmoRoute: typeof UmoRoute
  AuthAuthViewRoute: typeof AuthAuthViewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/umo': {
      id: '/umo'
      path: '/umo'
      fullPath: '/umo'
      preLoaderRoute: typeof UmoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-sms': {
      id: '/mobile-sms'
      path: '/mobile-sms'
      fullPath: '/mobile-sms'
      preLoaderRoute: typeof MobileSmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-push': {
      id: '/mobile-push'
      path: '/mobile-push'
      fullPath: '/mobile-push'
      preLoaderRoute: typeof MobilePushRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grapes-preview': {
      id: '/grapes-preview'
      path: '/grapes-preview'
      fullPath: '/grapes-preview'
      preLoaderRoute: typeof GrapesPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grapes': {
      id: '/grapes'
      path: '/grapes'
      fullPath: '/grapes'
      preLoaderRoute: typeof GrapesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/$authView': {
      id: '/auth/$authView'
      path: '/auth/$authView'
      fullPath: '/auth/$authView'
      preLoaderRoute: typeof AuthAuthViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug': {
      id: '/_app/projects/$projectSlug'
      path: '/projects/$projectSlug'
      fullPath: '/projects/$projectSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/schema-builder/': {
      id: '/_app/schema-builder/'
      path: '/schema-builder'
      fullPath: '/schema-builder'
      preLoaderRoute: typeof AppSchemaBuilderIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization/': {
      id: '/_app/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AppOrganizationIndexRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization/settings': {
      id: '/_app/organization/settings'
      path: '/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof AppOrganizationSettingsRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/members': {
      id: '/_app/organization/members'
      path: '/members'
      fullPath: '/organization/members'
      preLoaderRoute: typeof AppOrganizationMembersRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/billing': {
      id: '/_app/organization/billing'
      path: '/billing'
      fullPath: '/organization/billing'
      preLoaderRoute: typeof AppOrganizationBillingRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/api-keys': {
      id: '/_app/organization/api-keys'
      path: '/api-keys'
      fullPath: '/organization/api-keys'
      preLoaderRoute: typeof AppOrganizationApiKeysRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/cli-project-select/$sessionId': {
      id: '/_app/cli-project-select/$sessionId'
      path: '/cli-project-select/$sessionId'
      fullPath: '/cli-project-select/$sessionId'
      preLoaderRoute: typeof AppCliProjectSelectSessionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account/$accountView': {
      id: '/_app/account/$accountView'
      path: '/account/$accountView'
      fullPath: '/account/$accountView'
      preLoaderRoute: typeof AppAccountAccountViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/cli-auth/$sessionId/': {
      id: '/_app/cli-auth/$sessionId/'
      path: '/cli-auth/$sessionId'
      fullPath: '/cli-auth/$sessionId'
      preLoaderRoute: typeof AppCliAuthSessionIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/_layout': {
      id: '/_app/projects/$projectSlug/_layout'
      path: '/projects/$projectSlug'
      fullPath: '/projects/$projectSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutRouteRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/templates/': {
      id: '/_app/projects/$projectSlug/templates/'
      path: '/templates'
      fullPath: '/projects/$projectSlug/templates'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/_layout/': {
      id: '/_app/projects/$projectSlug/_layout/'
      path: '/'
      fullPath: '/projects/$projectSlug/'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/cli-auth/$sessionId/complete/': {
      id: '/_app/cli-auth/$sessionId/complete/'
      path: '/cli-auth/$sessionId/complete'
      fullPath: '/cli-auth/$sessionId/complete'
      preLoaderRoute: typeof AppCliAuthSessionIdCompleteIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/settings': {
      id: '/_app/projects/$projectSlug/_layout/settings'
      path: '/settings'
      fullPath: '/projects/$projectSlug/settings'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutSettingsRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/media': {
      id: '/_app/projects/$projectSlug/_layout/media'
      path: '/media'
      fullPath: '/projects/$projectSlug/media'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutMediaRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/analytics': {
      id: '/_app/projects/$projectSlug/_layout/analytics'
      path: '/analytics'
      fullPath: '/projects/$projectSlug/analytics'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutAnalyticsRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/cli-auth/$sessionId/complete/$organizationSlug': {
      id: '/_app/cli-auth/$sessionId/complete/$organizationSlug'
      path: '/cli-auth/$sessionId/complete/$organizationSlug'
      fullPath: '/cli-auth/$sessionId/complete/$organizationSlug'
      preLoaderRoute: typeof AppCliAuthSessionIdCompleteOrganizationSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/'
      path: '/templates/$templateSlug'
      fullPath: '/projects/$projectSlug/templates/$templateSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/logs': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/logs'
      path: '/templates/$templateSlug/logs'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/logs'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/edit': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/edit'
      path: '/templates/$templateSlug/edit'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/edit'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport
      parentRoute: typeof AppProjectsProjectSlugRoute
    }
  }
}

interface AppOrganizationRouteRouteChildren {
  AppOrganizationApiKeysRoute: typeof AppOrganizationApiKeysRoute
  AppOrganizationBillingRoute: typeof AppOrganizationBillingRoute
  AppOrganizationMembersRoute: typeof AppOrganizationMembersRoute
  AppOrganizationSettingsRoute: typeof AppOrganizationSettingsRoute
  AppOrganizationIndexRoute: typeof AppOrganizationIndexRoute
}

const AppOrganizationRouteRouteChildren: AppOrganizationRouteRouteChildren = {
  AppOrganizationApiKeysRoute: AppOrganizationApiKeysRoute,
  AppOrganizationBillingRoute: AppOrganizationBillingRoute,
  AppOrganizationMembersRoute: AppOrganizationMembersRoute,
  AppOrganizationSettingsRoute: AppOrganizationSettingsRoute,
  AppOrganizationIndexRoute: AppOrganizationIndexRoute,
}

const AppOrganizationRouteRouteWithChildren =
  AppOrganizationRouteRoute._addFileChildren(AppOrganizationRouteRouteChildren)

interface AppProjectsProjectSlugLayoutRouteRouteChildren {
  AppProjectsProjectSlugLayoutAnalyticsRoute: typeof AppProjectsProjectSlugLayoutAnalyticsRoute
  AppProjectsProjectSlugLayoutMediaRoute: typeof AppProjectsProjectSlugLayoutMediaRoute
  AppProjectsProjectSlugLayoutSettingsRoute: typeof AppProjectsProjectSlugLayoutSettingsRoute
  AppProjectsProjectSlugLayoutIndexRoute: typeof AppProjectsProjectSlugLayoutIndexRoute
}

const AppProjectsProjectSlugLayoutRouteRouteChildren: AppProjectsProjectSlugLayoutRouteRouteChildren =
  {
    AppProjectsProjectSlugLayoutAnalyticsRoute:
      AppProjectsProjectSlugLayoutAnalyticsRoute,
    AppProjectsProjectSlugLayoutMediaRoute:
      AppProjectsProjectSlugLayoutMediaRoute,
    AppProjectsProjectSlugLayoutSettingsRoute:
      AppProjectsProjectSlugLayoutSettingsRoute,
    AppProjectsProjectSlugLayoutIndexRoute:
      AppProjectsProjectSlugLayoutIndexRoute,
  }

const AppProjectsProjectSlugLayoutRouteRouteWithChildren =
  AppProjectsProjectSlugLayoutRouteRoute._addFileChildren(
    AppProjectsProjectSlugLayoutRouteRouteChildren,
  )

interface AppProjectsProjectSlugRouteChildren {
  AppProjectsProjectSlugLayoutRouteRoute: typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  AppProjectsProjectSlugTemplatesIndexRoute: typeof AppProjectsProjectSlugTemplatesIndexRoute
  AppProjectsProjectSlugTemplatesTemplateSlugEditRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}

const AppProjectsProjectSlugRouteChildren: AppProjectsProjectSlugRouteChildren =
  {
    AppProjectsProjectSlugLayoutRouteRoute:
      AppProjectsProjectSlugLayoutRouteRouteWithChildren,
    AppProjectsProjectSlugTemplatesIndexRoute:
      AppProjectsProjectSlugTemplatesIndexRoute,
    AppProjectsProjectSlugTemplatesTemplateSlugEditRoute:
      AppProjectsProjectSlugTemplatesTemplateSlugEditRoute,
    AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute:
      AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute,
    AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute:
      AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute,
  }

const AppProjectsProjectSlugRouteWithChildren =
  AppProjectsProjectSlugRoute._addFileChildren(
    AppProjectsProjectSlugRouteChildren,
  )

interface AppRouteRouteChildren {
  AppOrganizationRouteRoute: typeof AppOrganizationRouteRouteWithChildren
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountAccountViewRoute: typeof AppAccountAccountViewRoute
  AppCliProjectSelectSessionIdRoute: typeof AppCliProjectSelectSessionIdRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppSchemaBuilderIndexRoute: typeof AppSchemaBuilderIndexRoute
  AppProjectsProjectSlugRoute: typeof AppProjectsProjectSlugRouteWithChildren
  AppCliAuthSessionIdIndexRoute: typeof AppCliAuthSessionIdIndexRoute
  AppCliAuthSessionIdCompleteOrganizationSlugRoute: typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  AppCliAuthSessionIdCompleteIndexRoute: typeof AppCliAuthSessionIdCompleteIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppOrganizationRouteRoute: AppOrganizationRouteRouteWithChildren,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountAccountViewRoute: AppAccountAccountViewRoute,
  AppCliProjectSelectSessionIdRoute: AppCliProjectSelectSessionIdRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppSchemaBuilderIndexRoute: AppSchemaBuilderIndexRoute,
  AppProjectsProjectSlugRoute: AppProjectsProjectSlugRouteWithChildren,
  AppCliAuthSessionIdIndexRoute: AppCliAuthSessionIdIndexRoute,
  AppCliAuthSessionIdCompleteOrganizationSlugRoute:
    AppCliAuthSessionIdCompleteOrganizationSlugRoute,
  AppCliAuthSessionIdCompleteIndexRoute: AppCliAuthSessionIdCompleteIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DashboardRoute: DashboardRoute,
  GrapesRoute: GrapesRoute,
  GrapesPreviewRoute: GrapesPreviewRoute,
  MobilePushRoute: MobilePushRoute,
  MobileSmsRoute: MobileSmsRoute,
  UmoRoute: UmoRoute,
  AuthAuthViewRoute: AuthAuthViewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
